import { render, staticRenderFns } from "./StudentsAdmin.vue?vue&type=template&id=03b3b41c&"
import script from "./StudentsAdmin.vue?vue&type=script&lang=js&"
export * from "./StudentsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports